import {
    APPTOOLBAR_RESET_APP_STATE,
    FLOATING_TOOL_TEE_MOVED,
    FLOATING_TOOL_TEE_OPEN,
    FLOATING_TOOL_TEE_CLOSE,
    MULTIBED_RESET_APP_STATE,
} from "../lib/types";

const initialState = {
    x: 0,
    y: 80,
    row: null,
    col: null,
    accessory: null,
    openDialog: false,
};

export default ( state = initialState, action ) => {
    switch (action.type) {
        case FLOATING_TOOL_TEE_MOVED:
            return {
                ...state,
                x: action.payload.x,
                y: action.payload.y,
            };

        case FLOATING_TOOL_TEE_OPEN:
            return {
                ...state,
                row: action.payload.row,
                col: action.payload.col,
                accessory: action.payload.accessory,
                openDialog: true,
            };

        case FLOATING_TOOL_TEE_CLOSE:
            return {
                ...state,
                row: null,
                col: null,
                accessory: null,
                openDialog: false,
            };

        case MULTIBED_RESET_APP_STATE:
        case APPTOOLBAR_RESET_APP_STATE:
            return initialState;

        default:
            return state;
    }
};



// WEBPACK FOOTER //
// ./src/reducers/floating-tool-inserta-tee-reducer.js